import _classCallCheck from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { decode, encode } from 'he';
/**
 * Node Class as base class for TextNode and HTMLElement.
 */

var Node = /*#__PURE__*/function () {
  function Node() {
    var parentNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var range = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Node);

    this.parentNode = parentNode;
    this.childNodes = [];
    Object.defineProperty(this, 'range', {
      enumerable: false,
      writable: true,
      configurable: true,
      value: range !== null && range !== void 0 ? range : [-1, -1]
    });
  }

  _createClass(Node, [{
    key: "innerText",
    get: function get() {
      return this.rawText;
    }
  }, {
    key: "textContent",
    get: function get() {
      return decode(this.rawText);
    },
    set: function set(val) {
      this.rawText = encode(val);
    }
  }]);

  return Node;
}();

export { Node as default };